import InputBase from "@mui/material/InputBase";
import { alpha, styled } from "@mui/material/styles";
import React from "react";
const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
}));


const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    // padding: theme.spacing(0, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(1)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "18ch",
    },
    border: "1px solid #ccc",
    borderRadius: "5px",
  },
}));

const SearchBar = ({ filteredRows, searchValue, placeHolder = "Search" }) => {
  return (
    <Search>
      <StyledInputBase
        placeholder={placeHolder}
        inputProps={{ "aria-label": "search" }}
        onChange={(searchVal) => filteredRows(searchVal.target.value)}
        value={searchValue}
      />
    </Search>
  );
};
export default SearchBar;
